// Registers public/sw.js so the app shell and the Care Consultation PDF
// templates are available offline after at least one successful online visit.
export function register() {
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(err => {
      console.error('Service worker registration failed:', err);
    });
  });
}
